import React, { createContext, ReactNode } from 'react'

import { useLocalStorageState } from './hooks'
import { phoneAuthService } from './services/phone-auth'

const User = {
  name: null,
  gender: null,
  setUser: () => {},
  clearUser: () => {},
  isAuthenticated: false,
  logout: () => {},
}

export const UserContext = createContext(User)
interface IUserContextProviderProps {
  children: ReactNode;
}

export const UserContextProvider = ({ children }: IUserContextProviderProps) => {
  const [user, setUser] = useLocalStorageState('user')

  const clearUser = () => setUser({})

  const logout = () => {
    phoneAuthService.clearAuth()
    clearUser()
  }

  const value = {
    name: user?.name,
    gender: user?.gender,
    isAuthenticated: phoneAuthService.isAuthenticated(),
    setUser,
    clearUser,
    logout,
  }

  return (
    <UserContext.Provider value={value} >
      {children}
    </UserContext.Provider>
  )
}
